import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, provideRouter, withEnabledBlockingInitialNavigation } from "@angular/router";
import { AucRootAuthnComponent } from "@auction-ui/root/authn/root.authn.component";
import { AucRootUnAuthnComponent } from "@auction-ui/root/unauthn/root.unauthn.component";
import { AucRouteNames } from "@auction-ui/route.names";
import { MF_UNAUTHN_ROUTES, MfAuthGuardService, MfFillRouterOutletComponent, MfRoutes } from "@pattonair/material-framework";
import { AucAuctionDetailComponent } from "./auctionDetail/auction.detail.component";
import { AucAuctionListComponent } from "./auctionList/auction.list.component";
import { AucBidListComponent } from "./bidList/bid.list.component";
import { AucHomeComponent } from "./home/home.component";
import { AucWonListComponent } from "./wonList/won.list.component";

const ROUTING_CONFIGURATION: ExtraOptions = {
  paramsInheritanceStrategy: "always"
};

const AUC_ROUTES: MfRoutes = [
  {
    path: "",
    redirectTo: AucRouteNames.routeAuctionsList,
    pathMatch: "full",
  },
  {
    component: AucRootUnAuthnComponent,
    path: "",
    children: [
      ...MF_UNAUTHN_ROUTES,
    ],
  },
  {
    component: AucRootAuthnComponent,
    path: "",
    children: [
      {
        path: AucRouteNames.partNameHome,
        component: AucHomeComponent,
        canActivate: [MfAuthGuardService],
        breadcrumb: {
          alias: "AUC_BREADCRUMB_KEY_HOME",
          label: "Home",
          routeInterceptor: () => AucRouteNames.routeHome
        },
      },
      {
        path: "",
        component: MfFillRouterOutletComponent,
        canActivate: [MfAuthGuardService],
        breadcrumb: {
          alias: "AUC_BREADCRUMB_KEY_HOME",
          label: "Home",
          routeInterceptor: () => AucRouteNames.routeHome,
        },
        children: [
          {
            path: "",
            redirectTo: AucRouteNames.routeAuctionsList,
            pathMatch: "full",
          },
          {
            path: AucRouteNames.partNameAuctions,
            component: MfFillRouterOutletComponent,
            canActivate: [MfAuthGuardService],
            breadcrumb: {
              alias: "AUC_BREADCRUMB_KEY_AUCTIONS",
              label: "Auctions",
              routeInterceptor: () => AucRouteNames.routeAuctionsList,
            },
            children: [
              {
                path: "",
                redirectTo: AucRouteNames.partNameList,
                pathMatch: "full",
              },
              {
                path: AucRouteNames.partNameList,
                component: AucAuctionListComponent,
                canActivate: [MfAuthGuardService],
              },
              {
                path: AucRouteNames.partNameParameterAuctionDetailAuctionId,
                component: AucAuctionDetailComponent,
                canActivate: [MfAuthGuardService],
                breadcrumb: {
                  alias: "AUC_BREADCRUMB_KEY_PRODUCT_DETAIL",
                  label: "Detail",
                },
              },
            ]
          },
        ],
      },
      {
        path: "",
        component: MfFillRouterOutletComponent,
        canActivate: [MfAuthGuardService],
        breadcrumb: {
          alias: "AUC_BREADCRUMB_KEY_HOME",
          label: "Home",
          routeInterceptor: () => AucRouteNames.routeHome,
        },
        children: [
          {
            path: "",
            redirectTo: AucRouteNames.routeWonList,
            pathMatch: "full",
          },
          {
            path: AucRouteNames.partNameWon,
            component: MfFillRouterOutletComponent,
            canActivate: [MfAuthGuardService],
            breadcrumb: {
              alias: "AUC_BREADCRUMB_KEY_WON",
              label: "Won Auctions",
              routeInterceptor: () => AucRouteNames.routeWonList,
            },
            children: [
              {
                path: "",
                redirectTo: AucRouteNames.partNameList,
                pathMatch: "full",
              },
              {
                path: AucRouteNames.partNameList,
                component: AucWonListComponent,
                canActivate: [MfAuthGuardService],
              },
              {
                path: AucRouteNames.partNameParameterAuctionDetailAuctionId,
                component: AucAuctionDetailComponent,
                canActivate: [MfAuthGuardService],
                breadcrumb: {
                  alias: "AUC_BREADCRUMB_KEY_PRODUCT_DETAIL",
                  label: "Detail",
                },
              },
            ]
          },
        ],
      },
      {
        path: "",
        component: MfFillRouterOutletComponent,
        canActivate: [MfAuthGuardService],
        breadcrumb: {
          alias: "AUC_BREADCRUMB_KEY_HOME",
          label: "Home",
          routeInterceptor: () => AucRouteNames.routeHome,
        },
        children: [
          {
            path: "",
            redirectTo: AucRouteNames.routeBidList,
            pathMatch: "full",
          },
          {
            path: AucRouteNames.partNameBids,
            component: MfFillRouterOutletComponent,
            canActivate: [MfAuthGuardService],
            breadcrumb: {
              alias: "AUC_BREADCRUMB_KEY_WON",
              label: "Bidding Auctions",
              routeInterceptor: () => AucRouteNames.routeBidList,
            },
            children: [
              {
                path: "",
                redirectTo: AucRouteNames.partNameList,
                pathMatch: "full",
              },
              {
                path: AucRouteNames.partNameList,
                component: AucBidListComponent,
                canActivate: [MfAuthGuardService],
              },
              {
                path: AucRouteNames.partNameParameterAuctionDetailAuctionId,
                component: AucAuctionDetailComponent,
                canActivate: [MfAuthGuardService],
                breadcrumb: {
                  alias: "AUC_BREADCRUMB_KEY_PRODUCT_DETAIL",
                  label: "Detail",
                },
              },
            ]
          },
        ],
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(AUC_ROUTES, ROUTING_CONFIGURATION)],
  exports: [RouterModule],
  providers: [
    provideRouter(AUC_ROUTES, withEnabledBlockingInitialNavigation())
  ]
})
export class AucRoutingModule { }